// @flow

import * as React from 'react';
import classnames from 'classnames';
import Box from 'sail/Box';
import {BodyAlt} from 'sail/Text';
import Icon from 'sail/Icon';
import {warning, check, cancel} from 'sail/Icon/Assets';
import {TopHandles, BottomHandles, LeftHandles, RightHandles} from '../Handles';

import type {StateDiagramNodeState} from '../types';

import './StateDiagram.scss';

type StateDiagramNodeData = {|
  text: string,
  state: StateDiagramNodeState,
|};

type StateDiagramNodeProps = {|
  data: StateDiagramNodeData,
|};

const ICONS = {
  success: check,
  warning,
  error: cancel,
  canceled: cancel,
};

export const StateDiagramNode = ({data}: StateDiagramNodeProps) => {
  const {text, state} = data;

  const textColor = !state || state === 'neutral' ? 'gray900' : 'white';
  const icon =
    !state || state === 'neutral' ? null : (
      <Box margin={{right: 8}}>
        <Icon icon={ICONS[state]} color={'white'} />
      </Box>
    );

  return (
    <Box
      className={classnames(
        'StateDiagramNode',
        `StateDiagramNode-${state || 'neutral'}`,
      )}
      padding={{vertical: 16, horizontal: 24}}
      flex={{alignItems: 'center', justifyContent: 'center'}}
    >
      <TopHandles />
      <LeftHandles />
      <BottomHandles />
      <Box flexBasis="100%" flex={{alignItems: 'center'}}>
        {icon}
        <BodyAlt align="center" color={textColor}>
          {React.Children.toArray(text)}
        </BodyAlt>
      </Box>
      <RightHandles />
    </Box>
  );
};
